import React from "react";
import { Create, SimpleForm, useGetOne, useNotify, useRedirect, useStore } from "react-admin";
import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import ListIcon from "@mui/icons-material/List";
import BackButtonToolbar from "features/BackButtonToolbar";
import { SectionTitle } from "features/SectionTitle";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";
import { useNotifyError } from "utils/useNotifyError";
import {
  HEALTHCARE_CAMPAIGNS,
  HEALTHCARE_CAMPAIGNS_APPLICATIONS,
  MOBILE_BREAKPOINT,
  SpecialistServicePath,
} from "utils/constants";
import { HEALTHCARE_CAMPAIGNS_APPLICATIONS_STORE_KEY } from "./List";
import CreateForm from "./CreateForm";
import { isAcceptingApplications } from "./utils";

const CreateHealthcareCampaignApplication = () => {
  const notify = useNotify();
  const notifyError = useNotifyError();
  const redirect = useRedirect();
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  // The campaign is the one committed in the list's filter.
  const [filters] = useStore(HEALTHCARE_CAMPAIGNS_APPLICATIONS_STORE_KEY, null);
  const campaignId = filters?.campaignId;

  const { data: campaign } = useGetOne(
    SpecialistServicePath + HEALTHCARE_CAMPAIGNS,
    { id: campaignId },
    { enabled: !!campaignId },
  );

  const save = async ({ desiredDate, secondName, ...data }) => {
    try {
      await dataProvider.customRequest(
        specialistRequests.postHealthcareCampaignApplication(campaignId),
        {
          ...data,
          secondName: secondName ?? "",
          // CreateForm clears it for courses without hasDesiredDate.
          desiredDate: desiredDate ?? null,
        },
        "POST",
      );
      notify("Кандидатурата е добавена успешно", { type: "success" });
      redirect("list", SpecialistServicePath + HEALTHCARE_CAMPAIGNS_APPLICATIONS);
    } catch (err) {
      notifyError(err);
    }
  };

  return (
    <Create
      title="Добавяне на кандидатура - кампания за здравни грижи"
      actions={campaignId ? <BackButtonToolbar /> : null}
    >
      {!campaignId ? (
        // No toolbar here (actions={null}), so on mobile the fixed app bar would cover the message.
        <Box sx={{ p: 3, pt: isMobile ? 10 : 3, textAlign: "center" }}>
          <SectionTitle
            paddingY={2}
            title="Моля, първо изберете кампания от списъка с кандидатури."
            color="secondary"
          />
          {/* component={Link} renders the MUI Button as a router link, so `to` navigates. */}
          <Button
            variant="contained"
            startIcon={<ListIcon />}
            component={Link}
            to={`/${SpecialistServicePath}${HEALTHCARE_CAMPAIGNS_APPLICATIONS}`}
          >
            Към списъка с кампании
          </Button>
        </Box>
      ) : !campaign ? null : isAcceptingApplications(campaign) ? (
        <SimpleForm onSubmit={save}>
          <Typography
            color="primary"
            sx={{ mb: 2 }}
          >
            Кампания: {campaign.coursesYear}
          </Typography>
          <CreateForm campaign={campaign} />
        </SimpleForm>
      ) : (
        <Typography
          align="center"
          color="secondary"
          sx={{ p: 3 }}
        >
          Кампанията не е в период за кандидатстване.
        </Typography>
      )}
    </Create>
  );
};

export default CreateHealthcareCampaignApplication;
